import { Injectable, inject } from '@angular/core';

import { APP_CONFIG } from '../injection-tokens';

@Injectable({ providedIn: 'root' })
export class ImageResourceService {
  private readonly config = inject(APP_CONFIG, { optional: true });

  public get baseUrl(): string {
    return this.config?.dsCdnUrl ?? 'assets/images/';
  }

  public getImageUrl(imagePath: string, imagesSet?: string): string {
    const base = this.baseUrl.endsWith('/') ? this.baseUrl : `${this.baseUrl}/`;

    return `${base}${imagesSet ? `${imagesSet}/` : ''}${imagePath}`;
  }
}
